import MESSAGES from "@constants/messages.constants";
import { setAlert, setAlertMessage } from "@reducers/alert.reducer";
import { setUserTokenAction } from "@reducers/app.reducer";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  getTokenDataAPI,
  refreshPasswordAPI,
} from "./refresh-password.service";
import RefreshPasswordTemplate from "./refresh-password.template";

const {
  ALERT_TYPES: { ERROR },
} = MESSAGES;

const RefreshPasswordComponent = () => {
  const { alertMessage } = useSelector((state) => state.alert);
  const { token } = useSelector((state) => state.app);
  const [user, setUser] = useState(null);
  const [formTriggers, setFormTriggers] = useState({
    submitTrigger: 0,
    validationTrigger: 0,
  });
  const dispatch = useDispatch();
  const history = useHistory();

  const handleSubmit = async ({ values, errors }) => {
    console.log({ values, errors });

    if (errors.length > 0) return;

    // INFO :  construct blocked ip payload
    let payload = {};
    for (let i = 0; i < values.length; i++) {
      payload[values[i].name] = values[i].value;
    }

    const response = await refreshPasswordAPI({ ...payload, token });
    console.log({ response });
    if (response.status) {
      dispatch(
        setAlert({
          alert: true,
          type: "success",
          title: "Success",
          message: "Login Successfully!",
        })
      );
      dispatch(
        setUserTokenAction({ token: response.token, user: response.user })
      );
      history.push("/dashboard");
    } else {
      dispatch(setAlertMessage({ type: ERROR, message: response.message }));
    }
  };

  const onSubmitTrigger = (e) => {
    e.preventDefault();
    setFormTriggers({
      ...formTriggers,
      submitTrigger: formTriggers.submitTrigger + 1,
    });
  };

  const onLoad = async () => {
    const tokenData = await getTokenDataAPI();
    console.log({ tokenData });
    if (tokenData.status) {
      setUser(tokenData.data);
    }
  };

  useEffect(() => {
    onLoad();
  }, []);

  const templateModal = {
    formTriggers,
    user,
    alertMessage,
  };

  const templateEvents = {
    handleSubmit,
    onSubmitTrigger,
  };
  return (
    <RefreshPasswordTemplate
      templateModal={templateModal}
      templateEvents={templateEvents}
    />
  );
};

export default RefreshPasswordComponent;
